import { z } from "zod";
import {
  IS_PAYMENT_RECEIVED,
  PAID_AMOUNT,
  PAID_DATE,
  PAYMENT_RECEIVED_ON,
  PAYMENT_REMARKS,
  PAYMENT_STATUS
} from "./consts";

export const schema = z.object({
  [PAID_AMOUNT]: z.string().min(1, "This field is required"),
  [PAID_DATE]: z.string().min(1, "This field is required"),
  [IS_PAYMENT_RECEIVED]: z.boolean().optional(),
  [PAYMENT_STATUS]: z.string().min(1, "This field is required"),
  [PAYMENT_RECEIVED_ON]: z.string().optional(),
  [PAYMENT_REMARKS]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
